import React from 'react';
import { get } from "lodash"

import { lbsToKg, cmToMeters, ftToMeters } from "./../../../utils/converter"
import Icon from "../../../shared/items/static/icon"

import ParamsBlock from './paramsBlock';
import { heightTypeData } from "./../height/static.heightData"
import { currentWeightTypeData } from "./../currentWeight/static.currentWeightData"
import locales from "./../../../content.json"

import styles from "./bmiResultBlock.module.scss"

const MIN_VALUE = 15
const MAX_VALUE = 40

const inRange = value => {
  return value < MIN_VALUE
    ? MIN_VALUE
    : value > MAX_VALUE
      ? MAX_VALUE
      : value
}

const BmiWeightWtate = value => {
  if (value <= 18.49)
    return locales[window.userLang].weight_1
  else if (value <= 24.99)
    return locales[window.userLang].weight_2
  else if (value > 24.99)
    return locales[window.userLang].weight_3
}

const BmiResultBlock = props => {
  const { data } = props
  const currentWeightKG = get(data, ["currentWeight", "type"]) === currentWeightTypeData.kg.value
    ? get(data, ["currentWeight", "value"])
    : get(data, ["currentWeight", "type"]) === currentWeightTypeData.lbs.value
      ? lbsToKg(get(data, ["currentWeight", "value"]))
      : get(data, ["currentWeight", "value"])

  const heightMeters = get(data, ["height", "type"]) === heightTypeData.ft.value
    ? ftToMeters(get(data, ["height", "value"]))
    : get(data, ["height", "type"]) === heightTypeData.cm.value
      ? cmToMeters(get(data, ["height", "value"]))
      : get(data, ["height", "value"])

  const bmiProgress = currentWeightKG / Math.pow(heightMeters, 2)
  const left = (inRange(bmiProgress) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100

  return (
    <ParamsBlock
      title="BMI"
      helpText={<span>{locales[window.userLang].your_weight} <b>{BmiWeightWtate(bmiProgress)}</b></span>}
      value={bmiProgress.toFixed(2)}
    >
      <div className={styles.bmiGrafic}>
        <div className={styles.graficLine}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={styles.graficPointer}>
          <div className={styles.pointer} style={{ left: left + "%" }}>
            <Icon name="triangle" />
            <div className={styles.backIcon}>
              <Icon name="triangle" />
            </div>
          </div>
        </div>
        <div className={styles.graficValues}>
          <span>{MIN_VALUE}</span>
          <span>18.5</span>
          <span>25</span>
          <span>30</span>
          <span>{MAX_VALUE}</span>
        </div>
      </div>
    </ParamsBlock>
  )
}

export default BmiResultBlock;